import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MemberOverviewDialogComponent } from '../../dialogs/member-overview-dialog/member-overview-dialog.component';
import { PolicyService } from 'src/app/modules/ent/services/policy.service';
import { PolicyholderGroupService } from 'src/app/modules/ent/services/policyholder-group.service';
import { ProcessingClass } from 'src/app/modules/clm/types/processing-class.enum';
import { of} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';

@Component({
  selector: 'app-death-status-icon',
  templateUrl: './death-status-icon.component.html',
  styleUrls: ['../../../../../styles/global/_management-styles.scss']
})
export class DeathStatusIconComponent implements OnInit {
  @Input() personId: number;
  @Input() optionCode: string;
  @Input() membershipNumber: string;

  policyNumber: string;
  policyId: number;

  constructor(
    private dialog: MatDialog,
    private policyService: PolicyService,
    private policyholderGroupService: PolicyholderGroupService,
  ) {}

  ngOnInit(): void {
  }

  openMemberOverviewDialog() {
    if (!this.personId && !this.policyNumber) {
      return;
    }

    this.policyService.getPolicyBy(this.personId, ProcessingClass.Medical)
    .pipe(
      tap((policyDTO) => {
        this.policyNumber = policyDTO?.number;
        this.policyId = policyDTO?.policyId;
      }),
      switchMap((policyDTO) => {
        const groupValue = policyDTO?.policyholderGroup?.value;
        return groupValue
          ? this.policyholderGroupService.getPolicyholderGroup(groupValue)
          : of(null);
      }),
    )
    .subscribe(group=> {
      this.dialog.open(MemberOverviewDialogComponent, {
      width: '80vw',
      height: '80vh',
      data: {
        personId: this.personId,
        optionCode: this.optionCode,
        membershipNumber: this.membershipNumber,
        policyId: this.policyId,
        policyNumber: this.policyNumber,
        policyHoliderGroupId: group?.policyholderGroupId
      },
      panelClass: 'gd-member-overview-dialog',
    });
    });
    
  }
}
